<template>
  <FormField
    :id="id"
    :class="wrapperClass"
    :label="label"
    :label-inside="labelInside"
    :is-disabled="isDisabled"
    :is-required="isRequired"
    :is-label-visible="isLabelVisible"
    :is-field-focused="isFocused || modelValue.length > 0"
    :is-error="isError"
    :message-fixed="messageFixed"
    :message="message"
    :is-message-visible="isMessageVisible"
  >
    <textarea
      :id="id"
      v-bind="$attrs"
      :value="modelValue"
      :disabled="isDisabled"
      :placeholder="!labelInside ? placeholder : undefined"
      :class="[
        'transition-colors duration-300 ease-out',
        labelInside ? 'pb-[5px] pt-5' : 'py-3',
        inputClass
      ]"
      @input="updateValue"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
    <slot />
  </FormField>
</template>

<script setup lang="ts">
import type { FormFieldProps } from './FormField.vue'

type FormTextareaProps = {
  inputClass?: HTMLElement['className']
  modelValue?: HTMLTextAreaElement['value']
  placeholder?: HTMLTextAreaElement['placeholder']
} & Pick<
  FormFieldProps,
  | 'wrapperClass'
  | 'label'
  | 'labelClass'
  | 'labelInside'
  | 'inputLabelClass'
  | 'isLabelVisible'
  | 'isRequired'
  | 'isDisabled'
  | 'isError'
  | 'messageFixed'
  | 'message'
  | 'isMessageVisible'
>

defineOptions({
  inheritAttrs: false
})

withDefaults(defineProps<FormTextareaProps>(), {
  inputClass: `form-textarea field-sizing-content block`,
  modelValue: '',
  placeholder: '',
  isLabelVisible: true,
  labelInside: false
})

const emit = defineEmits(['update:modelValue'])

const updateValue = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}

const id = useId()
const isFocused = ref(false)
</script>
